export default ( receiver ) => {
	const mail = document.createElement( 'a' );
	mail.id = 'openEmailClient';
	mail.href = `mailto:${receiver}`;
	mail.target = '_blank';
	mail.rel = 'noopener noreferrer';
	mail.click();
	mail.remove();
};
